module.exports = __webpack_public_path__ + "static/media/01_insideyourblood.27e6c0f9.jpg";